export default "__VITE_ASSET__BcIIaP9c__"